import InteractiveAvatar from "./interactive-avatar/interactive-avatar";
import RealtimeHandler from "./realtime-handler/realtime-handler";
import { Toaster } from "@/components/ui/sonner";
import HistoryPanel from "./history-panel/history-panel";
import { ChatStore } from "@/stores/ChatStore";
import { useEffect } from "react";
import PlayLayer from "@/components/ui/play-layer";
import StopButton from "@/components/ui/stop-button";
import StatusMessage from "@/components/ui/custom/status-message";
import { cn } from "@/lib/utils";
import SettingsStore from "@/stores/SettingsStore";
import DisplayedExternalLinks from "./displayed-external-links/displayed-external-links";
import UserInfoForm from "./user-info-form/user-info-form";
import { BrokerValidationDialog } from "./broker-validation-dialog/broker-validation-dialog";
import { BrokerInfoOverlay } from "./broker-info-overlay/broker-info-overlay";
import { ClaimStatusDialog } from "./claim-status-dialog/claim-status-dialog";
import { ClaimStatusOverlay } from "./claim-status-overlay/claim-status-overlay";
import MaintenanceOverlay from "./maintenance-overlay/maintenance-overlay";
import SessionTimeoutOverlay from "./session-timeout-overlay/session-timeout-overlay";
import { useBranding } from "@/hooks/useBranding";

function EmbeddedAvatar() {
  useBranding();
  const isRunning = ChatStore(state => state.isRunning);
  const isAvatarReady = ChatStore(state => state.isAvatarReady);
  const fetchPartialSettings = SettingsStore(state => state.fetchPartialSettings);
  const maintenanceMode = SettingsStore(state => state.maintenanceMode);
  const isLoading = SettingsStore(state => state.isLoading);

  useEffect(() => {
    fetchPartialSettings();
  }, [fetchPartialSettings]);

  const isAvatarSessionRunning = isRunning && isAvatarReady;

  if (maintenanceMode && !isLoading) {
    return (
      <div id="avatar-container" className="relative flex h-screen w-screen overflow-hidden">
        <main className={cn("relative", "h-full w-full")}>
          <MaintenanceOverlay />
        </main>
      </div>
    );
  }

  return (
    <div id="avatar-container" className="relative flex h-screen w-screen overflow-hidden">
      <main className={cn("relative", "h-full w-full")}>
        <InteractiveAvatar />
        <PlayLayer />
        {isAvatarSessionRunning && <RealtimeHandler />}
        <div className={"absolute left-4 top-4 flex flex-col gap-4"}>
          <StatusMessage />
          {isAvatarSessionRunning && <DisplayedExternalLinks />}
          {isAvatarSessionRunning && <BrokerInfoOverlay />}
          {isAvatarSessionRunning && <ClaimStatusOverlay />}
        </div>
        <div className={"absolute gap-4 py-2 bottom-4 left-4 flex"}>
          <div className={"flex flex-col gap-4 max-w-sm"}>
            {isAvatarSessionRunning && <StopButton />}
          </div>
          {isAvatarSessionRunning && <HistoryPanel />}
        </div>
        <UserInfoForm />
        <BrokerValidationDialog />
        <ClaimStatusDialog />
        <SessionTimeoutOverlay />
      </main>
      <Toaster expand />
    </div>
  );
}

export default EmbeddedAvatar;
